// Atoms
import { useAtomValue } from 'jotai';

import { selectedPostAtom } from '@/components/pages/giveaway-picker/Atoms/postsAtoms';
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
import { SummaryItemTitle } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary/components/SummaryItemTitle';
// Components
import { Post } from '@/components/pages/giveaway-picker/SelectPostWrapper/components/SelectPost/Post';

export default function SummaryItemSecondStep() {
    const currentStep = useAtomValue(currentStepAtom);
    const selectedPost = useAtomValue(selectedPostAtom);

    if (currentStep < 2) {
        return null;
    }

    return (
        <div data-testid="summary-item-2">
            <SummaryItemTitle step={1} />
            {selectedPost ? (
                <div className="flex items-center gap-3" data-testid="post-displayed">
                    <Post key={selectedPost.id} post={selectedPost} summaryItem={true} />
                </div>
            ) : null}
        </div>
    );
}
